import { defineModule, } from 'direct-vuex';
import type { GlobalConfig, } from '../self-serve/global-config';

export type GlobalConfigState = GlobalConfig;

export default defineModule({
	namespaced: false as const,
	state: { } as GlobalConfigState,
	getters: {
		getGlobalConfigValue(state) {
			return (key: keyof GlobalConfigState) => state[key];
		},
	},
	actions: {},
	mutations: {
		hydrateGlobalConfig(state, hydratedState: GlobalConfigState) {
			Object.assign(state, hydratedState);
		},
	},
});
